import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { Avatar } from 'primeng/avatar';
import { Carousel, CarouselPageEvent } from 'primeng/carousel';
import {
  SelectButton,
  SelectButtonOptionClickEvent,
} from 'primeng/selectbutton';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

interface CharacteristicsProps extends FormlyFieldProps {
  characteristics: {
    id: string;
    icon: string;
    label: string;
  }[];
  charactsResult: string[];
}

@Component({
  selector: 'characteristics-field',
  standalone: true,
  imports: [...FORM_IMPORTS, SelectButton, Carousel, Avatar],
  template: `
    <p-carousel
      [value]="this.props.characteristics"
      [numVisible]="1"
      [numScroll]="1"
      [showIndicators]="false"
      orientation="horizontal"
      [circular]="true"
      class="flex justify-center w-screen p-0"
      [nextButtonProps]="{}"
      [page]="pageIndex"
      (onPage)="onScroll($event)"
    >
      <ng-template let-charact #item>
        <div class="flex flex-col gap-4 items-center text-center">
          <div>
            <p-avatar shape="circle" [icon]="charact.icon" size="large">
            </p-avatar>
          </div>
          <div
            [innerHTML]="charact.label"
            class="text-sm flex flex-col gap-2"
          ></div>
          <p-selectbutton
            [options]="stateOptions"
            size="small"
            optionLabel="label"
            optionValue="value"
            aria-labelledby="basic"
            [allowEmpty]="false"
            (onOptionClick)="onOptionClick($event, charact.id)"
          />
        </div>
      </ng-template>
    </p-carousel>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CharacteristicsFieldType extends FieldType<
  FieldTypeConfig<CharacteristicsProps>
> {
  stateOptions = [
    { label: 'Si', value: true },
    { label: 'No', value: false },
  ];
  pageIndex: number = 0;

  onOptionClick(event: SelectButtonOptionClickEvent, id: string) {
    const { value } = event.option;
    const index = this.props.charactsResult?.indexOf(id);
    if (!value && index !== -1) this.props.charactsResult?.splice(index, 1);
    else if (value && index === -1) this.props.charactsResult?.push(id);
    this.pageIndex++;
    this.formControl.setValue(this.props.charactsResult);
  }

  onScroll(event: CarouselPageEvent) {
    this.pageIndex = event.page!;
  }
}
